import { Theme } from "@mui/material";

export const TicketTypeVariants = (theme: Theme) => {
  return {
    generalAdmission: {
      color: theme.colors["pink.500"],
    },
    accessibilityRequired: {
      color: theme.colors["green.400"],
    },
    vip: {
      color: theme.colors["orange.400"],
    },
    priority: {
      color: theme.colors["yellow.400"],
    },
    friendsAndFamily: {
      color: theme.colors["indigo.300"],
    },
    priorityAccessibility: {
      color: theme.colors["yellow.400"],
    }
  }
}
